module.exports = __webpack_public_path__ + "static/media/alex_g.81799666.jpg";